import ls from '@/util/ls';

export default {
	install(Vue, { store }) {
		if (!store) {
			throw new Error('please provide vuex/pathify store');
		}

		Vue.mixin({
			methods: {

				/**
				 * Test permission against global permissions or per project, if project provided
				 *
				 * @param {string} permission Permission name
				 * @returns {boolean}
				 */
				$userCan(permission) {
					if (store.get('superUser')) {
						return true;
					}

					const permissions = new Set(ls.get('permissions'));

					const currentProject = store.get('projects/currentProject');
					if (currentProject) {
						currentProject.permissions.forEach(p => permissions.add(p));
					}

					return permissions.has(permission);
				},

			},
		});
	},
}
